
















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IUser, ILogworkAmountMember } from '@/lib/interfaces';
import { ERole } from '@/lib/enums';
import { arrayToHash, parseJWT } from '@/lib/helpers/common.helper';
import { getAmountsByMember } from '@/services/api.service';
import { ruMonth } from '@/lib/helpers/common.helper';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['users']),
})
export default class Users extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  private month: number = new Date().getMonth();
  private amounts: { [key: string]: ILogworkAmountMember } | {} = {};
  private ruMonth = ruMonth;

  private async updateData() {
    const curDate = new Date();
    const amounts = await getAmountsByMember({
      month: this.month + 1,
      year: curDate.getFullYear(),
    });
    this.amounts = arrayToHash(amounts);
  }

  private get isOwner(): boolean {
    return parseJWT()!.roles.includes(ERole.owner);
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    let amounts: ILogworkAmountMember[] = [];
    if (parseJWT()!.roles.includes(ERole.owner)) {
      const curDate = new Date();
      amounts = await getAmountsByMember({
        month: curDate.getMonth() + 1,
        year: curDate.getFullYear(),
      });
    }
    next((vm: Users) => {
      vm.amounts = arrayToHash(amounts);
    });
  }
}
